import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import styled from '@emotion/styled';
import { Center } from '@xsite-ui/common.elements';
import React from 'react';

var _excluded = ["icon", "variant", "onClick", "as", "href", "target"];

var _templateObject;
var IconButtonContainer = styled(Center)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var IconButton = function IconButton(_ref) {
  var icon = _ref.icon,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      onClick = _ref.onClick,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'button' : _ref$as,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '' : _ref$href,
      _ref$target = _ref.target,
      target = _ref$target === void 0 ? '' : _ref$target,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var clickHandler = function clickHandler(e) {
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };

  return /*#__PURE__*/React.createElement(IconButtonContainer, _extends({
    tx: "iconButton",
    variant: variant,
    onClick: clickHandler,
    "data-testid": "icon-button",
    as: as,
    href: href,
    target: target
  }, restProps), icon);
};

export { IconButton as default };
